var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice365(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4402 3.67126C19.3627 3.92439 20.0002 4.75314 20.0002 5.69814V18.2794C20.0002 19.2319 19.3495 20.0644 18.4158 20.3119L12.6445 21.9319L14.4989 18V5.49939L12.9258 2.05688L18.4402 3.67126Z",
    fill: "#E65100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4997 17.4994V19.4644C14.4997 21.3656 12.5891 22.5881 10.9916 21.7088L7.52285 19.4869C7.1216 19.2544 6.9041 18.7556 7.04097 18.2588C7.1666 17.7956 7.6016 17.4994 8.05722 17.4994H14.4997Z",
    fill: "#B71C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72875 16.1138L6.02813 16.8657C5.3475 17.2669 4.5 16.7588 4.5 15.9507V7.45128C4.5 6.6844 4.905 5.97753 5.5575 5.60628L11.4731 2.26315C12.8344 1.49065 14.4994 2.5069 14.4994 4.10815V5.65315L9.48188 7.3969C8.88938 7.63128 8.49938 8.21815 8.49938 8.87065V14.7432C8.49938 15.3094 8.205 15.8325 7.72875 16.1138Z",
    fill: "#B71C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365);
export default __webpack_public_path__ + "static/media/Office365.484169b1cda9b01b509ae0a8cb619c49.svg";
export { ForwardRef as ReactComponent };